module.exports = __webpack_public_path__ + "img/Frame 1058five.abe9b0de.png";